export default "__VITE_ASSET__BCbj9MwD__"